import * as labelConfigs from './labelConfigs'; 
// MENU NAMES FOR SUPERADMIN LOGIN 
    // LEFT SIDE MENUBAR FOR SUPERADMIN LOGIN 
    export const LM_SA_DASHBOARD      = labelConfigs.LBL_DASHBOARD;
    export const LM_SA_QUOTES         = labelConfigs.LBL_QUOTES;
    export const LM_SA_EVENTS         = labelConfigs.LBL_EVENTS;
    export const LM_SA_AFFILIATES     = labelConfigs.LBL_AFFILIATES;
    export const LM_SA_CLIENTS        = labelConfigs.LBL_CLIENTS;
    export const LM_SA_LOGS           = labelConfigs.LBL_LOGS;
    export const LM_SA_FEEDBACK       = labelConfigs.LBL_FEEDBACK;
    export const LM_SA_ASSOCIATES     = labelConfigs.LBL_ASSOCIATES;
    export const LM_SA_SETTINGS       = labelConfigs.LBL_SETTINGS;
    
    // RIGHT SIDE MENUBAR FOR SUPERADMIN LOGIN 




// MENU NAMES FOR AFFILIATE LOGIN 
    // LEFT SIDE MENUBAR FOR AFFILIATE LOGIN 
    export const LM_AFLT_DASHBOARD          = labelConfigs.LBL_DASHBOARD;
    export const LM_AFLT_QUOTES             = labelConfigs.LBL_QUOTES;
    export const LM_AFLT_EVENTS             = labelConfigs.LBL_EVENTS;
    export const LM_AFLT_SHIFTS             = labelConfigs.LBL_SHIFTS;
    export const LM_AFLT_SCHEDULE           = labelConfigs.LBL_SCHEDULE; 
    export const LM_AFLT_SCHEDULE_CALENDAR  = labelConfigs.LBL_SCHEDULE_SHIFT_CALENDAR; 
    export const LM_AFLT_TIMESHEET          = labelConfigs.LBL_TIMESHEET;
    export const LM_AFLT_UNAVAILABILITY     = labelConfigs.LBL_CREW_UNAVAILABILITY;
    export const LM_AFLT_CLIENTS            = labelConfigs.LBL_CLIENTS;
    export const LM_AFLT_CREW_LIST          = labelConfigs.LBL_CREW_LIST;
    export const LM_AFLT_FEEDBACK           = labelConfigs.LBL_FEEDBACK;
    export const LM_AFLT_ASSOCIATES         = labelConfigs.LBL_ASSOCIATES;
    export const LM_AFLT_LOGS               = labelConfigs.LBL_LOGS;
    export const LM_AFLT_REPORTS            = labelConfigs.LBL_REPORTS;
    export const LM_AFLT_CERTIFICATES       = labelConfigs.LBL_CERTIFICATES
    export const LM_AFLT_SETTINGS           = labelConfigs.LBL_SETTINGS;

    // RUGHT SIDE MENUBAR FOR AFFILIATE LOGIN 





// MENU NAMES FOR CLIENT LOGIN 
    // LEFT SIDE MENUBAR FOR CLIENT LOGIN 
    export const LM_CLIENT_DASHBOARD      = labelConfigs.LBL_DASHBOARD;
    export const LM_CLIENT_QUOTES         = labelConfigs.LBL_QUOTES;
    export const LM_CLIENT_EVENTS         = labelConfigs.LBL_EVENTS;
    export const LM_CLIENT_TIMESHEET      = labelConfigs.LBL_TIMESHEET;
    export const LM_CLIENT_FEEDBACK       = labelConfigs.LBL_FEEDBACK;
    export const LM_CLIENT_ASSOCIATES     = labelConfigs.LBL_ASSOCIATES;
    export const LM_CLIENT_LOGS           = labelConfigs.LBL_LOGS;

    


